/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：142
 */

"use strict"

function r(e) {
  if (undefined === e) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
  }
  return e
}
export { r as a }
export default r
